module.exports = __webpack_public_path__ + "static/media/spoiler_1.2cff0718.png";